var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5998 11.5998V7.0998M7.9998 11.5998V4.3998M4.3998 11.5998V9.7998M2.5998 15.1998C1.60569 15.1998 0.799805 14.3939 0.799805 13.3998V2.5998C0.799805 1.60569 1.60569 0.799805 2.5998 0.799805H13.3998C14.3939 0.799805 15.1998 1.60569 15.1998 2.5998V13.3998C15.1998 14.3939 14.3939 15.1998 13.3998 15.1998H2.5998Z",
    stroke: "#222124",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/graph-icon.ffb511ee6ec90489310dd98b16739867.svg";
export { ForwardRef as ReactComponent };